<template>
  <form class="nix-login-form" @submit.prevent>
    <h1 class="nix-login-form__title">Login de Acesso</h1>

    <InputText
      v-model="login.userName"
      title="Usuário "
      :formName="formName"
      field="userName"
      :required="true"
      :maxLength="50"
    >
      <div class="glyphicon"><i class="fas fa-user"></i></div>
    </InputText>

    <InputPassword
      v-model="login.password"
      title="Senha"
      :formName="formName"
      field="password"
      :required="true"
      :maxLength="50"
    >
      <div class="glyphicon"><i class="fas fa-lock"></i></div>
    </InputPassword>

    <Button
      _key="sigin"
      type="primary"
      title="Entrar"
      classIcon="fad fa-sign-out-alt"
      size="medium"
      :disabled="!isFormValid(formName)"
      :clicked="handleLogin"
    />

    <SendConfirmMailMobile
      v-if="showSendConfirmMailMobile"
      typeConfirm="email"
      :email="emailToConfirm"
    />

    <span class="nix-login-form__link" @click="$emit('forgot-password')">
      Esqueceu a senha?
    </span>
  </form>
</template>

<script>
import InputText from '@/ui/forms/InputText.vue'
import InputPassword from '@/ui/forms/InputPassword.vue'
import Button from '@/ui/forms/Button.vue'
import SendConfirmMailMobile from '@/modules/auth/components/SendConfirmMailMobile.vue'
import { authService } from '@/modules/auth/services/auth.service'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'LoginForm',
  components: { InputText, InputPassword, Button, SendConfirmMailMobile },
  data() {
    return {
      formName: 'login',
      login: {
        userName: '',
        password: '',
      },
      showSendConfirmMailMobile: false,
      emailToConfirm: '',
    }
  },
  computed: {
    ...mapGetters('validation', ['isFormValid']),
    ...mapGetters('generic', ['event']),
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == 'stopSendConfirmEmailMobile') this.showSendConfirmMailMobile = false
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations('generic', ['removeLoading']),
    async handleLogin() {
      this.showSendConfirmMailMobile = false
      try {
        const response = await authService.login(this.login)
        if (response && response.data && response.data.success) {
          const content = response.data.content
          this.$emit('login-success', { content })
        }
      } catch (e) {
        // conta pendente de confirmação: a api devolve o e-mail em `content`
        if (e && e.content) {
          this.emailToConfirm = e.content
          this.showSendConfirmMailMobile = true
        }
      } finally {
        this.removeLoading(['sigin'])
      }
    },
  },
}
</script>

<style scoped>
.nix-login-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.nix-login-form__title {
  margin: 0 0 4px;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 1px;
  text-align: center;
  color: var(--text-primary);
}

.nix-login-form__link {
  display: block;
  margin-top: 4px;
  font-size: 14px;
  letter-spacing: 0.5px;
  text-align: center;
  color: var(--color-brand);
  cursor: pointer;
}

.nix-login-form__link:hover {
  color: var(--color-brand-hover);
  text-decoration: underline;
}

.glyphicon {
  display: inline-flex;
  align-items: center;
  margin-right: 6px;
  top: 50%;
  padding-top: 0;
  transform: translateY(-50%);
}

@media (max-width: 480px) {
  .nix-login-form__title { font-size: 20px; }
}
</style>
